import { ensureAppInfoReady } from './appInfo'
import { bindAnalyticsLifecycle } from './queue'

export { ensureAppInfoReady, getAppInfo, isInAppWebView } from './appInfo'
export { getAnalyticsBaseURL, getAnalyticsProjectId, isAnalyticsEnabled } from './config'
export { bindAnalyticsLifecycle, enqueueAnalyticsEvent, flushAnalyticsQueue } from './queue'
export { track } from './track'
export {
  KYC_EVENTS,
  getKycStepIndex,
  trackAccountOpenStart,
  trackKycStepView,
  trackKycStepComplete,
  trackKycIdOcrResult,
  trackKycRiskAnswer,
  trackAccountOpenSubmit
} from './kyc'
export type { KycStepCode } from './kyc'
export { API_EVENTS, trackApiRequest, trackApiResponse } from './api'
export type { ApiRequestAnalyticsCtx } from './api'
export {
  ACCOUNT_OPEN_API_EVENTS,
  ACCOUNT_OPEN_API_PATHS,
  trackAccountOpenApiRequest,
  trackAccountOpenApiResponse,
  beginAccountOpenApiTracking,
  finishAccountOpenApiTracking,
  normalizeAccountOpenApiPath,
  resolveAccountOpenBizContext,
  shouldTrackAccountOpenApi,
  toRedactedJsonString,
  buildAccountOpenRequestParams
} from './events/accountOpenApi'
export type {
  AccountOpenApiCtx,
  AccountOpenApiSource,
  AccountOpenBizModule
} from './events/accountOpenApi'
export type { AnalyticsEventPayload, AnalyticsTrackInput } from './types'

/** 启动期：hydrate + 生命周期 flush */
export function initAnalytics(): void {
  bindAnalyticsLifecycle()
  void ensureAppInfoReady()
}
